import { HTMLAttributes, ReactNode } from 'react';
import { Chip, ChipProps, Grid } from '@mui/material';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { ConditionalTooltip } from '@/exports/columnCommonComponents';
import styled from '@emotion/styled';
export interface InventoryMetadataChip {
  label: string;
  value?: string;
  color?: string;
  icon?:
    | {
        name: string;
        size?: number;
      }
    | ReactNode;
  variant?: ChipProps['variant'] | 'dashed';
  style?: HTMLAttributes<HTMLDivElement>['style'];
}

const MetadataTag = ({ value, label, color = 'default', variant = 'filled', icon, style }: InventoryMetadataChip) => {
  const isDashed = variant === 'dashed';
  const renderedIcon =
    icon && typeof icon === 'object' && 'name' in icon ? (
      <PolarisIcon icon={icon?.name} height={icon?.size || 15} style={{ marginRight: 3 }} />
    ) : (
      icon
    );

  return (
    <ConditionalTooltip title={label || ''} show={!!label} placement="bottom">
      <StyledChip
        label={
          <StyledGrid container>
            {!!renderedIcon && renderedIcon}
            <span>{value || label}</span>
          </StyledGrid>
        }
        color={color as ChipProps['color']}
        variant={isDashed ? 'outlined' : variant}
        dashed={+isDashed}
        style={style}
      />
    </ConditionalTooltip>
  );
};

export default MetadataTag;

const StyledGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 15em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex-direction: row;
  flex-wrap: nowrap;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const StyledChip = styled(Chip)<{ dashed?: number }>`
  border-style: ${({ dashed }) => (dashed ? 'dashed' : 'solid')};
  opacity: ${({ dashed }) => (dashed ? 0.8 : 1)};

  border-radius: 5px;
  height: 26px;
  max-width: 15em;
  font-size: 11px !important;
  margin-right: 5px;

  label {
    padding-left: 0px;
    padding-right: 0px;
    margin-right: 5px;
  }

  label + strong {
    opacity: 0.5;
    margin-right: ${({ theme }) => theme.spacing(3)};
  }
`;
